export interface Ticker {
    stop(): void;
}

export type TickerFactory = (periodMs: number, onTick: () => void) => Ticker;

export const createTimerTicker: TickerFactory = (periodMs, onTick) => {
    const handle = setInterval(onTick, periodMs);
    return { stop: () => clearInterval(handle) };
};

/** Ticks from a Web Worker; falls back to a main-thread timer where workers are unavailable or fail. */
export const createWorkerTicker: TickerFactory = (periodMs, onTick) => {
    if (typeof Worker === 'undefined') return createTimerTicker(periodMs, onTick);
    let stopped = false;
    let fallback: Ticker | undefined;
    let worker: Worker | undefined;
    const tick = () => {
        if (!stopped) onTick();
    };
    const useTimer = () => {
        worker?.terminate();
        worker = undefined;
        if (!stopped) fallback ??= createTimerTicker(periodMs, tick);
    };
    try {
        worker = new Worker(new URL('./ticker.worker.ts', import.meta.url), { type: 'module' });
        worker.onmessage = tick;
        worker.onerror = useTimer;
        worker.postMessage({ cmd: 'start', periodMs });
    } catch {
        useTimer();
    }
    return {
        stop: () => {
            stopped = true;
            fallback?.stop();
            worker?.postMessage({ cmd: 'stop' });
            worker?.terminate();
        }
    };
};
